export const getCompanyInfo = content => ({
    type: 'getinfo',
    content
});


// WEBPACK FOOTER //
// ./src/redux/actions/company.js